import type { ElementType } from 'react';
import {
  Alert,
  Box,
  CircularProgress,
  Typography,
  SvgIconProps,
} from '@mui/material';

export const SectionEmptyState = ({
  icon: Icon,
  message,
  compact = false,
}: {
  icon: ElementType<SvgIconProps>;
  message: string;
  compact?: boolean;
}) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: compact ? 'row' : 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: compact ? 1.5 : 2,
      py: compact ? 2 : 5,
      px: 2,
      color: 'text.secondary',
      textAlign: compact ? 'left' : 'center',
    }}
  >
    <Icon
      aria-hidden="true"
      sx={{ fontSize: compact ? 28 : 40, strokeWidth: 1.5, flexShrink: 0 }}
    />
    <Typography variant={compact ? 'body2' : 'body1'} color="inherit">
      {message}
    </Typography>
  </Box>
);

export const LoadingState = ({ label = 'Loading…' }: { label?: string }) => (
  <Box
    role="status"
    sx={{
      display: 'grid',
      justifyItems: 'center',
      gap: 2,
      py: { xs: 6, sm: 8 },
    }}
  >
    <CircularProgress size={28} thickness={3} />
    <Typography color="text.secondary">{label}</Typography>
  </Box>
);
export const EmptyState = ({
  title,
  description,
}: {
  title: string;
  description?: string;
}) => (
  <Box
    sx={{
      textAlign: 'center',
      py: { xs: 6, sm: 8 },
      px: 3,
      maxWidth: 440,
      mx: 'auto',
    }}
  >
    <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
      {title}
    </Typography>
    {description && (
      <Typography color="text.secondary" sx={{ lineHeight: 1.7 }}>
        {description}
      </Typography>
    )}
  </Box>
);
export const ErrorState = ({ message }: { message: string }) => (
  <Alert severity="error" role="alert">
    {message}
  </Alert>
);
